import React from 'react';
import moment from 'moment';

// México eliminó el horario de verano en 2022 (Diario Oficial, 26-oct-2022):
// la zona centro del país queda fija en UTC-6 todo el año, sin transiciones
// que rastrear. Se usa un offset fijo en vez de moment-timezone (evita una
// dependencia nueva solo para esto).
const MEXICO_UTC_OFFSET_HOURS = -6;

export function formatDateTime(iso) {
    if (!iso) return null;
    return {
        local: `${moment(iso)
            .utcOffset(MEXICO_UTC_OFFSET_HOURS)
            .format('YYYY-MM-DD HH:mm')} (UTC-6)`,
        utc: moment(iso).utc().format('YYYY-MM-DD HH:mm[ UTC]'),
    };
}

export function DateTimeCell({iso}) {
    const formatted = formatDateTime(iso);
    if (!formatted) return <>-</>;
    return <span title={formatted.utc}>{formatted.local}</span>;
}

/**
 * Para `event.startsAt`: se guarda con sufijo `Z` pero el reloj ya es la
 * hora local del recinto (mala práctica conocida, no una fecha UTC real).
 * Convertirla de nuevo a UTC-6 la desplazaría dos veces. Se muestra tal cual
 * viene, sin ninguna conversión de zona horaria.
 */
export function VenueLocalDateTimeCell({iso}) {
    if (!iso) return <>-</>;
    return <span>{moment.utc(iso).format('YYYY-MM-DD HH:mm')}</span>;
}
